import Vue from 'vue';
import axios from 'axios';
import Home from '@/components/Home/Home.vue';
import AccessKey from '@/components/Register/AccessKey.vue';
import OAuth from '@/components/OAuth/OAuth.vue';
import Login from '@/components/Login/Login.vue';
import Logout from '@/components/Account/Logout.vue';
import Register from '@/components/Register/Register.vue';
import ConfirmRegister from '@/components/Register/ConfirmRegister.vue';
import RegisterValidate from '@/components/Register/RegisterValidate.vue';
import LoginPartnerCallback from '@/components/Login/PartnerCallback.vue';
import PartnerRegister from '@/components/Login/PartnerRegister.vue';
import PartnerConfirmRegister from '@/components/Login/PartnerConfirmRegister.vue';
import PasswordRecovery from '@/components/PasswordRecovery/PasswordRecovery.vue';
import PasswordRecoverySent from '@/components/PasswordRecovery/PasswordRecoverySent.vue';
import PasswordRecoveryReset from '@/components/PasswordRecovery/PasswordRecoveryReset.vue';
import AccountHome from '@/components/Account/Home.vue';
import Information from '@/components/Account/Information.vue';
import LinkAccount from '@/components/Account/LinkAccount.vue';
import Newsletter from '@/components/Account/Newsletter.vue';
import Cookies from '@/components/Account/Cookies.vue';
import DeletionRequest from '@/components/Account/DeletionRequest.vue';
import DeletionConfirm from '@/components/Account/DeletionConfirm.vue';
import Blocking from '@/components/Account/Blocking.vue';
import Unsubscribe from '@/components/Unsubscribe/Unsubscribe.vue';
import UpdateEmail from '@/components/Account/UpdateEmail.vue';
import UpdateEmailConfirm from '@/components/Account/UpdateEmailConfirm.vue';
import UpdateEmailRecovery from '@/components/Account/UpdateEmailRecovery.vue';
import UpdateEmailSuccess from '@/components/Account/UpdateEmailSuccess.vue';
import UpdateUsername from '@/components/Account/UpdateUsername.vue';
import ResetPassword from '@/components/Account/ResetPassword.vue';
import ConfirmEmail from '@/components/Register/ConfirmEmail.vue';
import ConfirmEmailSend from '@/components/Register/ConfirmEmailSend.vue';
import SteamCallback from '@/components/Steam/Callback.vue';
import SteamLink from '@/components/Steam/Link.vue';
import SteamUnlink from '@/components/Steam/Unlink.vue';
import TwitchCallback from '@/components/Twitch/Callback.vue';
import TwitchLink from '@/components/Twitch/Link.vue';
import TwitchUnlink from '@/components/Twitch/Unlink.vue';
import EpicGamesCallback from '@/components/EpicGames/Callback.vue';
import EpicGamesLink from '@/components/EpicGames/Link.vue';
import EpicGamesUnlink from '@/components/EpicGames/Unlink.vue';
import QualificationSurvey from '@/components/Survey/Qualification.vue';
import ConfirmQualificationSurvey from '@/components/Survey/Confirm.vue';
import Error from '@/components/Errors/Error.vue';
import BadRequest from '@/components/Errors/BadRequest.vue';
import Internal from '@/components/Errors/Internal.vue';
import NotFound from '@/components/Errors/NotFound.vue';
import store from '@/store';
import VueRouter from 'vue-router';
import accountService from '@/services/account.service';
import routeService from '@/services/route.service';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: { title: 'Home' }
    },
    {
      path: '/access-key',
      name: 'AccessKey',
      component: AccessKey,
      beforeEnter: (to, from, next) => {
        if (router.app.$data.RCEnvironment.VUE_APP_REGISTER_WITH_ACCESS_KEYS == false) {
          next({ name: "Register" });
        }
        else {
          next();
        }
      },
      meta: { title: 'Access Key' }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: (to, from, next) => {
        if (["CREATIVE-ASSEMBLY", "FOCUS"].includes(router.app.$data.RCEnvironment.VUE_APP_ENVIRONMENT)) {
          store.dispatch("updateIsLoading", true);

          const url = router.app.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "partner/" + router.app.$data.RCEnvironment.VUE_APP_PARTNER_NAME + "/login-url";
          axios
            .post(url, { ClientId: to.query.client_id, RedirectUrl: to.query.redirectUrl.toString() }, accountService.setConfig(router.app))
            .then(response => {
              accountService.handleResponse(response).then(result => {
                store.dispatch("updateIsLoading", false);

                window.location.href = routeService.getUrlWithUtm(router.app.$data.RCEnvironment.VUE_APP_ENVIRONMENT, result);
              });
            });
        }
        else if (["STILLFRONT"].includes(router.app.$data.RCEnvironment.VUE_APP_ENVIRONMENT)) {
          next({ name: "Home", query: { 'redirectUrl': to.query.redirectUrl } });
        }
        else {
          next();
        }
      },
      meta: { title: 'Login' }
    },
    {
      path: '/oauth',
      name: 'OAuth',
      component: OAuth,
    },
    {
      path: '/oauth/partner',
      name: 'LoginPartnerCallback',
      component: LoginPartnerCallback,
    },
    {
      path: '/oauth/partner/register',
      name: 'PartnerRegister',
      component: PartnerRegister,
      meta: { title: 'Register' }
    },
    {
      path: '/oauth/partner/register/confirm',
      name: 'PartnerConfirmRegister',
      component: PartnerConfirmRegister,
      meta: { title: 'Register partner confirmation' }
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      beforeEnter: (to, from, next) => {
        if (["CREATIVE-ASSEMBLY", "FOCUS"].includes(router.app.$data.RCEnvironment.VUE_APP_ENVIRONMENT)) {
          store.dispatch("updateIsLoading", true);

          const url = router.app.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "partner/" + router.app.$data.RCEnvironment.VUE_APP_PARTNER_NAME + "/register-url";
          axios
            .get(url, accountService.setConfig(router.app))
            .then(response => {
              accountService.handleResponse(response).then(result => {
                store.dispatch("updateIsLoading", false);
                window.location.href = routeService.getUrlWithUtm(router.app.$data.RCEnvironment.VUE_APP_ENVIRONMENT, result);
              });
            });
        } else if (["STILLFRONT"].includes(router.app.$data.RCEnvironment.VUE_APP_ENVIRONMENT)) {
          next({ name: "Home", query: { 'redirectUrl': to.query.redirectUrl } });
        } else if (router.app.$data.RCEnvironment.VUE_APP_REGISTER_WITH_ACCESS_KEYS == true && (store.getters.accessKey == null || store.getters.accessKey == "")) {
          next({ name: "AccessKey" });
        } else {
          next();
        }
      },

      meta: { title: 'Register' }
    },
    {
      path: '/register/confirm',
      name: 'ConfirmRegister',
      component: ConfirmRegister,
      meta: { title: 'Register confirmation' }
    },
    {
      path: '/register/validate',
      name: 'RegisterValidate',
      component: RegisterValidate,
      beforeEnter: (to, from, next) => {
        if (router.app.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'TWO-POINT-STUDIOS') {
          next();
        }
        else {
          next({ name: "Home" });
        }
      },
      meta: { title: 'Register validation' }
    },
    {
      path: '/password-recovery',
      name: 'PasswordRecovery',
      component: PasswordRecovery,
      beforeEnter: (to, from, next) => {
        if (["CREATIVE-ASSEMBLY", "FOCUS", "STILLFRONT"].includes(router.app.$data.RCEnvironment.VUE_APP_ENVIRONMENT)) {
          next({ name: "Home" });
        }
        else {
          next();
        }
      },
      meta: { title: 'Password Recovery' }
    },
    {
      path: '/password-recovery/sent',
      name: 'PasswordRecoverySent',
      component: PasswordRecoverySent,
      beforeEnter: (to, from, next) => {
        if (["CREATIVE-ASSEMBLY", "FOCUS", "STILLFRONT"].includes(router.app.$data.RCEnvironment.VUE_APP_ENVIRONMENT)) {
          next({ name: "Home" });
        }
        else {
          next();
        }
      },
      meta: { title: 'Password Recovery Confirmation' }
    },
    {
      path: '/password-recovery/reset',
      name: 'PasswordRecoveryReset',
      component: PasswordRecoveryReset,
      beforeEnter: (to, from, next) => {
        if (["CREATIVE-ASSEMBLY", "FOCUS", "STILLFRONT"].includes(router.app.$data.RCEnvironment.VUE_APP_ENVIRONMENT)) {
          next({ name: "Home" });
        }
        else {
          next();
        }
      },
      meta: { title: 'Password Recovery Reset' }
    },
    {
      path: '/account',
      component: AccountHome,
      children: [
        {
          path: '/account',
          name: 'Information',
          component: Information,
          meta: { title: 'My Information' }
        },
        {
          path: '/account/link-account',
          name: 'LinkAccount',
          component: LinkAccount,
          beforeEnter: (to, from, next) => {
            if (router.app.$data.RCEnvironment.VUE_APP_ENABLE_CONNECTIONS_SECTION == false) {
              next({ name: "Information" });
            }
            else {
              next();
            }
          },
          meta: { title: 'Link Account' }
        },
        {
          path: '/account/newsletter',
          name: 'Newsletter',
          component: Newsletter,
          beforeEnter: (to, from, next) => {
            if (router.app.$data.RCEnvironment.VUE_APP_ENABLE_CONNECTIONS_SECTION == false) {
              next({ name: "Information" });
            }
            else {
              next();
            }
          },
          meta: { title: 'Newsletter settings' }
        },
        {
          path: '/account/cookies',
          name: 'Cookies',
          component: Cookies,
          beforeEnter: (to, from, next) => {
            if (router.app.$data.RCEnvironment.VUE_APP_HAS_CUSTOM_COOKIES_MANAGEMENT == false) {
              next();
            }
          },
          meta: { title: 'Cookies control' }
        },
        {
          path: '/account/deletion-request',
          name: 'DeletionRequest',
          component: DeletionRequest,
          beforeEnter: (to, from, next) => {
            if (router.app.$data.RCEnvironment.VUE_APP_ENABLE_DELETION_SECTION == false) {
              next({ name: "Information" });
            }
            else {
              next();
            }
          },
          meta: { title: 'Deletion Request' }
        },
        {
          path: '/account/blocked-users-management',
          name: 'Blocking',
          component: Blocking,
          meta: { title: 'Blocked Users Management' }
        }
      ]
    },
    {
      path: '/deletion/confirm',
      name: 'ConfirmDeletion',
      component: DeletionConfirm,
      meta: { title: 'Deletion confirmation' }
    },
    {
      path: '/account/logout',
      name: 'Logout',
      component: Logout,
      meta: { title: 'Logout' }
    },
    {
      path: '/account/update-email',
      name: 'UpdateEmail',
      component: UpdateEmail,
      meta: { title: 'Update Email' }
    },
    {
      path: '/account/update-email/confirm',
      name: 'UpdateEmailConfirm',
      component: UpdateEmailConfirm,
      beforeEnter: (to, from, next) => {
        if (["CREATIVE-ASSEMBLY", "FOCUS", "STILLFRONT"].includes(router.app.$data.RCEnvironment.VUE_APP_ENVIRONMENT)) {
          next({ name: "Home" });
        }
        else {
          next();
        }
      },
      meta: { title: 'Update Email Confirm' }
    },
    {
      path: '/account/update-email/recovery',
      name: 'UpdateEmailRecovery',
      component: UpdateEmailRecovery,
      beforeEnter: (to, from, next) => {
        if (["CREATIVE-ASSEMBLY", "FOCUS", "STILLFRONT"].includes(router.app.$data.RCEnvironment.VUE_APP_ENVIRONMENT)) {
          next({ name: "Home" });
        }
        else {
          next();
        }
      },
      meta: { title: 'Update Email Recovery' }
    },
    {
      path: '/account/update-email/success',
      name: 'UpdateEmailSuccess',
      component: UpdateEmailSuccess,
      beforeEnter: (to, from, next) => {
        if (["CREATIVE-ASSEMBLY", "FOCUS", "STILLFRONT"].includes(router.app.$data.RCEnvironment.VUE_APP_ENVIRONMENT)) {
          next({ name: "Home" });
        }
        else {
          next();
        }
      },
      meta: { title: 'Update Email Success' }
    },
    {
      path: '/account/update-username',
      name: 'UpdateUsername',
      component: UpdateUsername,
      beforeEnter: (to, from, next) => {
        if (["CREATIVE-ASSEMBLY", "FOCUS", "STILLFRONT"].includes(router.app.$data.RCEnvironment.VUE_APP_ENVIRONMENT)) {
          next({ name: "Home" });
        }
        else {
          next();
        }
      },
      meta: { title: 'Update Username' }
    },
    {
      path: '/account/reset-password',
      name: 'ResetPassword',
      component: ResetPassword,
      beforeEnter: (to, from, next) => {
        if (["CREATIVE-ASSEMBLY", "FOCUS", "STILLFRONT"].includes(router.app.$data.RCEnvironment.VUE_APP_ENVIRONMENT)) {
          next({ name: "Home" });
        }
        else {
          next();
        }
      },
      meta: { title: 'Reset Password' }
    },
    {
      path: '/confirm-email',
      name: 'ConfirmEmail',
      component: ConfirmEmail,
      meta: { title: 'Confirm Email' }
    },
    {
      path: '/confirm-email/send',
      name: 'ConfirmEmailSend',
      component: ConfirmEmailSend,
      meta: { title: 'Send confirmation email' }
    },
    {
      path: '/steam/callback',
      name: 'SteamCallback',
      component: SteamCallback,
      meta: { title: 'Link Steam Account' }
    },
    {
      path: '/steam/link',
      name: 'SteamLink',
      component: SteamLink,
      meta: { title: 'Link Steam Account' }
    },
    {
      path: '/steam/unlink',
      name: 'SteamUnlink',
      component: SteamUnlink,
      meta: { title: 'Unlink Steam Account' }
    },
    {
      path: '/twitch/callback',
      name: 'TwitchCallback',
      component: TwitchCallback,
      meta: { title: 'Link Twitch Account' }
    },
    {
      path: '/twitch/link',
      name: 'TwitchLink',
      component: TwitchLink,
      meta: { title: 'Link Twitch Account' }
    },
    {
      path: '/twitch/unlink',
      name: 'TwitchUnlink',
      component: TwitchUnlink,
      meta: { title: 'Unlink Twitch Account' }
    },
    {
      path: '/epic-games/callback',
      name: 'EpicGamesCallback',
      component: EpicGamesCallback,
      meta: { title: 'Link EpicGames Account' }
    },
    {
      path: '/epic-games/link',
      name: 'EpicGamesLink',
      component: EpicGamesLink,
      meta: { title: 'Link EpicGames Account' }
    },
    {
      path: '/epic-games/unlink',
      name: 'EpicGamesUnlink',
      component: EpicGamesUnlink,
      meta: { title: 'Unlink EpicGames Account' }
    },
    {
      path: '/survey/qualification',
      name: 'QualificationSurvey',
      component: QualificationSurvey,
      meta: { title: 'Qualification survey' }
    },
    {
      path: '/survey/qualification/confirm',
      name: 'ConfirmQualificationSurvey',
      component: ConfirmQualificationSurvey,
      meta: { title: 'Qualification survey confirmation' }
    },
    {
      path: '/unsubscribe',
      name: 'Unsubscribe',
      component: Unsubscribe,
      meta: { title: 'Unsubscribe' }
    },
    {
      path: '/errors',
      name: 'Error',
      component: Error,
      meta: { title: 'Error' }
    },
    {
      path: '/errors/bad-request',
      name: 'BadRequestError',
      component: BadRequest,
      meta: { title: 'Bad Request' }
    },
    {
      path: '/errors/internal',
      name: 'InternalError',
      component: Internal,
      meta: { title: 'Internal Server Error' }
    },
    {
      path: '/errors/not-found',
      name: 'NotFoundError',
      component: NotFound,
      meta: { title: 'Not found' }
    },
  ]
});

export default router;
